import { render, staticRenderFns } from "./myheader.vue?vue&type=template&id=9fa939ba&scoped=true"
import script from "./myheader.vue?vue&type=script&lang=js"
export * from "./myheader.vue?vue&type=script&lang=js"
import style0 from "./myheader.vue?vue&type=style&index=0&id=9fa939ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa939ba",
  null
  
)

export default component.exports